"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._editBrand = exports._getGridHaulingBrand = exports._downloadTemplateHauling = exports._uploadProcessHauling = exports._uploadDocumentHauling = exports._getGridHistoryHauling = exports._getGridHauling = void 0;
const qs_1 = __importDefault(require("qs"));
const axios_1 = __importDefault(require("axios"));
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const error_response_1 = require("utils/error-response");
const _getGridHauling = ({ skip, take, filter, sort, }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter
        ? JSON.stringify({
            filters: filter.filters.map((item) => {
                if (item.field === 'contractor_code' ||
                    item.field === 'year' ||
                    item.field === 'brand_name') {
                    return item;
                }
                else {
                    return {
                        field: item.field,
                        operator: 'eq',
                        value: parseInt(item.value),
                    };
                }
            }),
            logic: filter.logic,
        })
        : undefined;
    const sortString = sort
        ? sort.length > 0
            ? JSON.stringify(sort)
            : undefined
        : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/hauling';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError, errorCode, errorMessage, data: [], countData: 0,
            totalOnMonth: {
                id: '',
                contractor_id: '',
                contractor_code: '',
                brand_id: '',
                brand_name: '',
                unit: 0,
                trip: 0,
                jan: 0,
                feb: 0,
                mar: 0,
                apr: 0,
                mei: 0,
                jun: 0,
                jul: 0,
                aug: 0,
                sep: 0,
                oct: 0,
                nov: 0,
                dec: 0,
                year: '',
                created_by: '',
                created_date: new Date(),
                modified_by: '',
                modified_date: new Date()
            }
        };
    }
});
exports._getGridHauling = _getGridHauling;
const _getGridHistoryHauling = ({ skip, take, filter, sort, }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort
        ? sort.length > 0
            ? JSON.stringify(sort)
            : undefined
        : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/hauling-log';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridHistoryHauling = _getGridHistoryHauling;
const _uploadDocumentHauling = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/upload-file';
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, name: '', countData: 0 };
    }
});
exports._uploadDocumentHauling = _uploadDocumentHauling;
const _uploadProcessHauling = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/hauling-upload';
    const data = qs_1.default.stringify(payload);
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, message: '', countData: 0 };
    }
});
exports._uploadProcessHauling = _uploadProcessHauling;
const _downloadTemplateHauling = ({ year, }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/hauling-template';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    if (year)
        config.params = { year };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, url: '', countData: 0 };
    }
});
exports._downloadTemplateHauling = _downloadTemplateHauling;
const _getGridHaulingBrand = ({ skip, take, filter, sort, }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter
        ? JSON.stringify({
            filters: filter.filters.map((item) => {
                if (item.field === 'year' || item.field === 'brand_code') {
                    return item;
                }
                else {
                    return {
                        field: item.field,
                        operator: 'eq',
                        value: parseInt(item.value),
                    };
                }
            }),
            logic: filter.logic,
        })
        : undefined;
    const sortString = sort
        ? sort.length > 0
            ? JSON.stringify(sort)
            : undefined
        : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/haulingBrand';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            data: {
                dataHaulingOnBrand: [],
                totalOnMonth: {
                    jan: 0,
                    feb: 0,
                    mar: 0,
                    apr: 0,
                    may: 0,
                    jun: 0,
                    jul: 0,
                    aug: 0,
                    sep: 0,
                    oct: 0,
                    nov: 0,
                    dec: 0,
                },
            },
            countData: 0,
        };
    }
});
exports._getGridHaulingBrand = _getGridHaulingBrand;
const _editBrand = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/haulingBrand';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.post(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: {
                id: ''
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: ''
            } });
    }
});
exports._editBrand = _editBrand;
